export const base_path = "/";
export const image_path = "/";
export const api_base_url = "https://dcm-api.ezyerp.biz";
